'use client';

// Core
import { FC } from 'react';

// Global UI components
import { Button } from '@/components/ui/button';

// Vendors
import Link from 'next/link';
import { useLocale } from '@/hooks/useLocale';

interface TBackButton {
  href: string;
  label: string;
}

export const BackButton: FC<TBackButton> = ({ label, href }) => {
  const locale = useLocale();

  return (
    <Button
      variant="link"
      className="font-semibold w-full"
      size="sm"
      asChild
      aria-label="Previous"
    >
      <Link href={`/${locale}/${href}`}>{label}</Link>
    </Button>
  );
};
